import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";

import { useDispatch } from "react-redux";
import { deleteMinute } from "../../redux/actions/minuteActions/MinuteAction";

const DeleteMinuteModal = (props) => {
  const dispatch = useDispatch();
  const handleSubmit = () => {
    dispatch(deleteMinute(props.meetingId, props.minuteId, props.accessToken));
    props.setIsDeleteMinuteModal(false);
  };

  const closeModal = () => {
    props.setIsDeleteMinuteModal(false);
  };

  return (
    <>
      <Modal
        show={props.IsDeleteMinuteModal}
        onHide={closeModal}
        backdrop="static"
      >
        <div className="modal-header">
          <h4 className="modal-title">Do you want to delete the minute ?</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            onClick={closeModal}
            className="add-minutes Mom-btn"
          >
            <p>Cancel</p>
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="create-meeting-button Mom-btn"
          >
            <p>Delete</p>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteMinuteModal;
